import { Promotion } from '@/core/domain/promotions/models/promotions-reponse.model';
import { GetPromotionsUseCase } from '@/core/domain/promotions/usecases/getPromotions.usecase';
import { Component, ViewEncapsulation, OnInit } from '@angular/core';

@Component({
    selector: 'fe-featured-promotions',
    templateUrl: './featured-promotions.component.html',
    styleUrls: ['./featured-promotions.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class FeaturedPromotionsComponent implements OnInit {
    public promotions: Promotion[] = [];
    public placeholders = new Array(4);
    isloading = true;

    constructor(private readonly getPromotionsUsecase: GetPromotionsUseCase) {}

    ngOnInit(): void {
        this.isloading = true;

        this.getPromotionsUsecase.execute().subscribe({
            next: (locations) => {
                if (locations.data) {
                    this.promotions = locations.data.promotions.filter(
                        (promotion: { seccionPromo: boolean }) =>
                            promotion.seccionPromo,
                    );
                }
            },
            error: () => {
                this.isloading = false;
            },
            complete: () => {
                this.isloading = false;
            },
        });
    }
}
